import { render, staticRenderFns } from "./FormSetupNew.vue?vue&type=template&id=2646d09a"
import script from "./FormSetupNew.vue?vue&type=script&lang=js"
export * from "./FormSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports